import Link from "next/link";

function SafeLink(props: any) {
  const {
    href, asPath, children, ...rest
  } = props;
  if (href) {
    return (
      <Link href={href} as={asPath || href} {...rest}>
        {children}
      </Link>
    );
  }
  return children;
}

export default SafeLink;
